export default "__VITE_ASSET__DZTYtUQ5__"